import { createFilterOptions } from '@mui/material/Autocomplete'

export const limitFilterTo100 = createFilterOptions({
  limit: 100,
})
